import { announcement } from "./registry";

/**
 * What's new, oldest first. Adding an announcement is a web-only change:
 * the API stores only what each user has seen, by the keys in `helpKeys`.
 * Media for an announcement with `video: true` is uploaded with
 * `make help-media ID=<id>`.
 */
export const ANNOUNCEMENTS = [
  announcement("pause-live", {
    title: "New: pause live data",
    body: "Press the LIVE badge to hold the dashboard still while the session keeps streaming, compare laps, then press it again to catch up.",
    released: "2026-10-10",
    // Pausing is about the session dashboard: introduce it there.
    route: "/eventdevice/:id",
    video: true,
    hints: [
      {
        route: "/eventdevice/:id",
        anchor: "eventdevice.live-pause",
        title: "Pause live data",
        body: "Press LIVE to pause the dashboard and compare laps. Press it again to resume.",
        placement: "bottom",
      },
    ],
  }),
];
